module.exports = __webpack_public_path__ + "static/g6-1e6256a024b283db3e7defc25ffce6bf.jpg";